// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr.text-to-parse, tr.text-to-parse td, tr.text-to-parse th {
	background-color: transparent;
}

tr.text-to-parse:hover {
	background-color: var(--bs-info-bg-subtle);
}`, "",{"version":3,"sources":["webpack://./src/views/textsBulkInsert/style.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,0CAA0C;AAC3C","sourcesContent":["tr.text-to-parse, tr.text-to-parse td, tr.text-to-parse th {\r\n\tbackground-color: transparent;\r\n}\r\n\r\ntr.text-to-parse:hover {\r\n\tbackground-color: var(--bs-info-bg-subtle);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
